import moment from 'moment';
import { ReminderStatus } from '../../../../../../Account/Profile/Reminders/util/reminders';

export const isReminderComplete = (reminder: any) =>
  ReminderStatus.getStatus(reminder) === ReminderStatus.DONE &&
  moment(ReminderStatus.getNextReminderDate(reminder)).isAfter();
